import { Pipe, PipeTransform } from "@angular/core";
import { IAudioProcessorTask } from "../../../core/models/audio-processor-task.model";

@Pipe({
  name: 'filterProjects'
})
export class FilterTasksPipe implements PipeTransform {

  transform(items: IAudioProcessorTask[], searchString: string): any[] {
    if (!items || !searchString) {
      return items;
    }
    return items.filter(item => {
      return item.name.toLowerCase().includes(searchString.toLowerCase()) ||
        item.taskBlocks.filter(block => {
          return block.originalFileName.toLowerCase().includes(searchString.toLowerCase()) ||
            block.menuItems.filter(menuItem => { return menuItem.caption.toLowerCase().includes(searchString.toLowerCase()) }).length > 0
        }).length > 0
    });
  }

}
